import { useMutation } from "@tanstack/react-query";
import CurrencyService from "../services";

const useDeleteCurrency = () => {
  return useMutation({
    mutationFn: (documentId: string) => CurrencyService.delete(documentId), // Assuming delete API takes an ID
    onSuccess: () => {
    },
    onError: (error) => {
      console.error("Error deleting currency:", error);
    },
  });
};

export default useDeleteCurrency;
